import { LOCATION_UPDATE } from "./types";

export const locationUpdate = info => async dispatch => {
  return dispatch({
    type: LOCATION_UPDATE,
    payload: info
  });
};
